<template>
  <div class="identifier_page" ref="mainTable">
    <a-table :data-source="tableData" :scroll="{ y: tableScrollY }" :pagination="false" rowKey="postId">
      <a-table-column title="岗位角色" key="postName" dataIndex="postName">
        <template slot-scope="text, record">
          <a-input v-model="record.postName" v-if="record.edit" />
          <span v-else>{{ record.postName }}</span>
        </template>
      </a-table-column>
      <a-table-column title="编号规则" key="postCode" dataIndex="postCode">
        <template slot-scope="text, record">
          <template v-if="record.edit">
            Al+年份（四位）+
            <a-input v-model="record.postCode" style="width: 40px" />
            +顺序号（三位）
          </template>
          <span v-else>Al+年份（四位）+{{ record.postCode }}+顺序号（三位）</span>
        </template>
      </a-table-column>
      <a-table-column title="操作">
        <template slot-scope="text, record, index">
          <a-button type="link" @click="changeInfo(index)" v-if="!record.edit"> 编辑 </a-button>
          <a-button type="link" @click="commitInfo(index)" v-if="record.edit"> 确定 </a-button>
          <a-divider type="vertical" />
          <a-button type="link" @click="getDetail(record)"> 人员 </a-button>
          <a-divider type="vertical" />
          <a-button type="link" @click="delInfo(index)" style="color: red"> 删除 </a-button>
        </template>
      </a-table-column>
    </a-table>
    <a-table
      bordered
      :data-source="addData"
      :scroll="{ y: 66 }"
      :pagination="false"
      rowKey="oid"
      :showHeader="false"
      class="addTable"
    >
      <a-table-column title="岗位角色" key="deptId" dataIndex="deptId">
        <template slot-scope="text, record">
          <a-input v-model="record.postName" placeholder="岗位角色" />
        </template>
      </a-table-column>
      <a-table-column title="编号规则" key="coverUrl" dataIndex="coverUrl">
        <template slot-scope="text, record">
          Al+年份（四位）+
          <a-input v-model="record.postCode" style="width: 40px" />
          +顺序号（三位）
        </template>
      </a-table-column>
      <a-table-column title="操作">
        <template slot-scope="text, record, index">
          <a-button type="link" @click="addInfo(index)"> 新增 </a-button>
        </template>
      </a-table-column>
    </a-table>
    <a-modal v-model="detailInfoShow" title="岗位人员" width="60%" :footer="null">
      <h3>岗位角色：{{ detail_info.postName }}</h3>
      <a-table
        style="margin-bottom: 20px"
        :data-source="detail_info.userPostList"
        bordered
        :scroll="{ y: 300 }"
        :pagination="false"
        rowKey="userId"
      >
        <a-table-column title="人员" dataIndex="userName"> </a-table-column>
        <a-table-column title="操作">
          <template slot-scope="text, record, index">
            <a-button type="link" @click="delUserItem(index)" style="color: red"> 删除 </a-button>
          </template>
        </a-table-column>
      </a-table>
      <div style="display: flex; justify-content: space-between">
        <div style="display: flex; align-items: center">
          <span>选择人员：</span>
          <a-dropdown v-model="selectUserVisible" :trigger="['click']">
            <div
              style="
                min-width: 210px;
                height: 32px;
                border: 1px solid #d9d9d9;
                border-radius: 4px;
                display: flex;
                align-items: center;
                padding-left: 6px;
              "
            >
              <template v-for="(item, index) in targetKeys">
                <a-tag :key="index" v-if="index <= 2">
                  {{ userIdLists[item].userName }}
                </a-tag>
              </template>
              <a-tag v-if="targetKeys.length > 2"> ... </a-tag>
              <span v-if="!targetKeys.length"> 请选择 </span>
            </div>

            <a-menu slot="overlay">
              <a-menu-item key="1">
                <a-transfer
                  :data-source="userLists"
                  show-search
                  :filterOption="filterOption"
                  @search="handleSearch"
                  @change="handleChange"
                  :target-keys="targetKeys"
                  :render="renderItem"
                  :disabled="disabled"
                  :list-style="{
                    width: '180px',
                    height: '380px',
                  }"
                />
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
        <div>
          <a-button type="primary" @click="detailInfoShow = false"> 取消 </a-button>
          <a-button type="primary" @click="confirmEdit(index)"> 确定 </a-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import {
  getIdentifierList,
  editIdentifierList,
  addIdentifierList,
  getIdentifierDetail,
  getCompanyUsers,
  identifierunbindPost,
  identifierbindPost,
  delIdentifierList,
} from '../../../../api/course'
import { tree_all } from '../../../../api/purchase'
import axios from 'axios'
export default {
  data() {
    return {
      tableData: [],
      tableScrollY: 300,
      selectIndex: '',
      addData: [
        {
          oid: 1,
          postName: undefined,
          postCode: '',
        },
      ],
      userInfo: {},
      positionX: 0,
      positionY: 0,
      selectColorCss: '',
      selectColorIndex: '',
      deptLists: [],
      options: {
        children: 'children',
        title: 'title',
        key: 'deptId',
        value: 'value',
      },
      detailInfoShow: false,
      detail_info: {
        userPostList: [],
      },
      userLists: [],
      userIdLists: {},
      targetKeys: [],
      selectUser: '',
      selectUserVisible: false,
      selectUseIds: [],
    }
  },
  mounted() {
    this.userInfo = this.$store.getters.userInfo
    this.getDeptLists()
    this.getUsers()
    this.$nextTick((res) => {
      this.tableScrollY = this.$refs.mainTable.offsetHeight - 130
    })
  },
  methods: {
    init() {
      this.get_lis()
      this.$nextTick((res) => {
        this.tableScrollY = this.$refs.mainTable.offsetHeight - 130
      })
    },
    delInfo(index) {
      let _this = this
      this.$confirm({
        title: '提示',
        content: '是否确认删除本条数据?',
        okText: '确定',
        cancelText: '取消',
        onOk() {
          delIdentifierList({
            id: _this.tableData[index].postId,
          }).then((res) => {
            if (res.code != 200) {
              return _this.$message.error(res.msg)
            }
            _this.$message.success('删除成功')
            _this.get_lis()
          })
        },
        onCancel() {
          _this.$message.info('已取消操作')
        },
      })
    },
    confirmEdit() {
      identifierbindPost({ postId: this.detail_info.postId, userIds: this.targetKeys }).then((res) => {
        if (res.code != 200) {
          return this.$message.error(res.msg)
        }
        this.detailInfoShow = false
        this.$message.success('保存成功')
      })
    },
    delUserItem(index) {
      let _this = this
      this.$confirm({
        title: '提示',
        content: '是否确认删除本条数据?',
        okText: '确定',
        cancelText: '取消',
        onOk() {
          identifierunbindPost({ userIds: _this.detail_info.userPostList[index].userId }).then((res) => {
            if (res.code != 200) {
              return _this.$message.error(res.msg)
            }
            _this.$message.success('删除成功')
            _this.getDetail(_this.detail_info)
          })
        },
        onCancel() {
          _this.$message.info('已取消操作')
        },
      })
    },
    renderItem(item) {
      let customLabel = <span class="custom-item">{item.title}</span>
      return {
        label: customLabel,
        value: item.key,
      }
    },
    handleSearch(dir, value) {},
    filterOption(inputValue, option) {
      return option.userName.indexOf(inputValue) > -1
    },
    handleChange(targetKeys, direction, moveKeys) {
      //   console.log(targetKeys)
      this.targetKeys = targetKeys
    },
    getUsers() {
      getCompanyUsers({ companyId: this.userInfo.companyId }).then((res) => {
        if (res.code != 200) {
          return this.$message.error(res.msg)
        }
        let userIdLists = {}
        for (let i = 0; i < res.data.length; i++) {
          res.data[i].key = res.data[i].userId
          res.data[i].title = res.data[i].userName
          res.data[i].disabled = this.selectUseIds.includes(res.data[i].userId)
          userIdLists[res.data[i].userId] = res.data[i]
        }
        this.userLists = res.data
        this.userIdLists = userIdLists
      })
    },
    getDetail(row) {
      getIdentifierDetail({ id: row.postId }).then((res) => {
        if (res.code != 200) {
          return this.$message.error(res.msg)
        }
        this.detail_info = res.data
        let selectUseIds = res.data.userList
        for (let i = 0; i < res.data.userPostList.length; i++) {
          if (!selectUseIds.includes(res.data.userPostList[i].userId)) {
            selectUseIds.push(res.data.userPostList[i].userId)
          }
        }
        this.selectUseIds = selectUseIds
        this.getUsers()
        this.targetKeys = []
        this.detailInfoShow = true
      })
    },
    addInfo() {
      addIdentifierList(this.addData[0]).then((res) => {
        if (res.code != 200) {
          return this.$message.error(res.msg)
        }
        this.addData[0].postName = undefined
        this.addData[0].postCode = ''
        this.$message.success(res.msg)
        this.get_lis()
      })
    },
    getDeptLists() {
      tree_all().then((res) => {
        this.deptLists = []
        res.data[0].forEach((item) => {
          if (item.deptId == this.userInfo.companyId) {
            this.deptLists = item.children
          }
        })
      })
    },
    commitInfo(index) {
      editIdentifierList(this.tableData[index]).then((res) => {
        if (res.code != 200) {
          return this.$message.error(res.msg)
        }
        this.$message.success('修改成功')
        this.get_lis()
      })
    },
    changeInfo(index) {
      this.$set(this.tableData[index], 'edit', true)
    },
    get_lis() {
      getIdentifierList().then((res) => {
        if (res.code != 200) {
          return this.$message.error(res.msg)
        }
        this.tableData = res.data.list
      })
    },
  },
}
</script>

<style scoped lang="less">
.identifier_page {
  width: 100%;
  height: 100%;
  position: relative;
  .addTable {
    /deep/ .ant-table-body {
      overflow: hidden !important;
    }
  }

  /deep/ .ant-btn-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  /deep/ .ant-divider {
    background: #1890ff;
  }
}
</style>